import React from 'react';

import {Container} from './styles';
import {Tooltip} from '@mantine/core';
import {useTheme} from 'styled-components';

export type VariantEnum = 'success' | 'error' | 'warn' | 'info';

export interface StatusButtonProps {
  variant?: VariantEnum;
  color?: string;
  text: string;
  round?: boolean;
  tooltip?: string;
}

const StatusButton: React.FC<StatusButtonProps> = ({
  variant = 'success',
  color,
  text,
  round = false,
  tooltip,
}) => {
  const {colors} = useTheme();

  const getColorByVariant = () => {
    if (color) return color;

    switch (variant) {
      case 'success':
        return colors.success;
      case 'error':
        return colors.red;
      case 'warn':
        return colors.secondary;
      default:
        return colors.info;
    }
  };

  if (tooltip)
    return (
      <Tooltip
        label={tooltip}
        w={250}
        multiline
        withArrow
        arrowSize={10}
        openDelay={500}>
        <Container backgroundColor={getColorByVariant()} {...{round}}>
          {text}
        </Container>
      </Tooltip>
    );

  return (
    <Container backgroundColor={getColorByVariant()} {...{round}}>
      {text}
    </Container>
  );
};

export default StatusButton;
